import { Accordion, AccordionTab } from "primereact/accordion";
import { Props } from "./types";

export function SyncLogsAccordion({ logs }: Props) {
  if (logs.length === 0) return null;

  return (
    <Accordion multiple>
      <AccordionTab header="Synchronization Details">
        <div
          className="flex flex-column gap-2"
          style={{ maxHeight: 180, overflowY: "auto" }}
        >
          {logs.map((l, idx) => (
            <small key={idx} className="text-600">
              {l}
            </small>
          ))}
        </div>
      </AccordionTab>
    </Accordion>
  );
}
